module.exports = __webpack_public_path__ + "static/media/icon_keyboard-right.088e2b5e.svg";